import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import history from '../history'
import apiM from '../GlobalEnv'

 

const CONFIRM = styled.button`
   padding: 1rem;
    font-size: large;
    border-radius: 3rem;
    width: 70%;
    font-weight: bold;
    color: white;
    outline: none;
    border: none;
    background: rgba(38, 20, 49, 0.97);
    letter-spacing: .1rem;
    cursor: pointer;
    transition: ease-in-out 1.1s;

    &:hover {
        color: black;
        border: 2px solid rgba(38, 20, 49, 0.97);
        background: white; 
        transition: ease-in-out .5s;
    }
    @media screen and (min-width: 48rem) {
        width: 35%;
    }
`
const PayConfirm = ({match}) => {
 
    const[ans, ] = useState('Confirming payment, pls wait');
    const[link, setLink] = useState('');
    const[err, setErr] = useState('');
    const[show, setShow] = useState(false);
    const[, setConfir] = useState('');
    const[viewB, setVB] = useState(false);
    useEffect(()=> {document.title = 'Confirm Payment'})
 useEffect(() => {
        const fetchData = async () => {
               try {

                //    console.log(apiM)
               
                const api = apiM + `/pay/confirmTrans/${sessionStorage.getItem('ref')}/${match.params.userID}`
                  
              sessionStorage.setItem('mail', match.params.userID)
              
                let pay = fetch(api)

            //    console.log(pay)

                let fRes = await pay
       
                let ans = await fRes.json()

                 console.log(ans)

                if(ans.error) throw new Error(ans.error)

                else if(ans.link.includes('confirmStatus')) {
                setTimeout(() => setLink(ans.link), 1100);
                } else throw Error
                
               } 
               catch (error) {
                   console.log(error)
                   
                    setErr(`An Error occured, pls refresh your tab. \n \n \t
                     If it persist you can email us here`)
               }
           
        }

         setTimeout(() => fetchData(), 1200);


         if(link.includes('confirmStatus')){
            
           (async function myname() {
                  try {
                     let res = await fetch(link)
         
                    let ans  =  await res.json()
         
                 //  console.log(ans)
                     const {confirm, refI, error} = ans
                    if(confirm === 'success'){
                        
                     //  console.log(ans.confirm)
                        
                     setConfir('Account confirmed')
                     
                     sessionStorage.removeItem('ref') 
         
                      localStorage.setItem('ref', refI)
         
                     // sessionStorage.setItem('dLogs', ans.confirm)
                     
                     setTimeout(() => history.replace('/login/new'), 1100);
                     }
                         
                      
                    else throw error
                } 
                catch (error) {
         
                 //  console.log(error)
                   setVB(false)
                  
                   setErr('error')
                   setShow(!show)
                }
             })()
         }
    },[link, match.params.userID, show])

   const handleConfirmAccount = async () => {
    //   console.log('clicked here')
       setVB(true)
       try {
            let res = await fetch(link)

           let ans  =  await res.json()

        //  console.log(ans)
            const {confirm, refI, error} = ans
           if(confirm === 'success'){
               
            //  console.log(ans.confirm)
               
            setConfir('Account confirmed')
            
            sessionStorage.removeItem('ref') 

             localStorage.setItem('ref', refI)

            // sessionStorage.setItem('dLogs', ans.confirm)
            
            setTimeout(() => history.replace('/login/new'), 1100);
            }
                
             
           else throw error
       } 
       catch (error) {

        //  console.log(error)
          setVB(false)
         
          setErr('error')
          setShow(!show)
       }
     }

  if(false) { 
       

          return ( 
            <>
        <span style={err === '' ? {display: 'none'} : {display:'block'}}>
        
        {/* <AlertMsg msg={err} action='FINANCE' getSt={() => setShow(show)} /> */}
        
        </span>
    <section style={{display:'flex', flexFlow:'column', height:'100vh', justifyContent:'center', alignItems:'center'}}>
    {/* 
    <span style={confirm === '' ? {display: 'none'} : {display:'block'}}>
    
    <AlertMsg msg={confirm} action='FINANCE' getSt={() => setShow(true)} />
    
    </span> */}
    
        <CheckCircleOutlinedIcon style={{fontSize:'10rem', color:'limegreen'}} />
    
        <h2>Successfull</h2>
    
         
            {/* <p>Check your mail box to confirm your account or  </p> */}
        <br />
        <br />
        <br />
            <CONFIRM onClick={handleConfirmAccount} style={viewB ? {display:'none'} : {display:'block'}}>Confirm now</CONFIRM>
       
    
            <img src={require('../Assets/Preloaders/25.gif')} alt='confirming payment' style={viewB === false ? {display:'none'}: {display:'block',height: '3rem', width:'3rem'}} /> 
    </section>
            </>
         );
       
    } 
    else {
        return (

        <>
        <span style={err === '' ? {display: 'none'} : {display:'block'}}>

        {/* <AlertMsg msg={err} action='FINANCE' getSt={() => setShow(true)} /> */}

        </span>

<section style={{display:'flex', flexFlow:'column', height:'100vh', justifyContent:'center', alignItems:'center'}}>

    <img src={require('../Assets/Preloaders/25.gif')} alt='confirming payment' style={{height: '7rem', width:'7rem'}} />

    <p style={{marginTop:'2rem', color:'maroon'}}>{ans} </p> 
    <p style={{color: 'silver'}}>(pls keep tab open and refresh if an error occurs) </p> 


</section>

        </>
        )
    }
}
 
export default PayConfirm;